import script from "./ManualSubmitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualSubmitForm.vue?vue&type=script&setup=true&lang=js"

import "./ManualSubmitForm.vue?vue&type=style&index=0&id=18714a9c&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18714a9c"]])

export default __exports__